import React, {useState, useEffect, useContext, createContext, } from 'react';
import { useLocation } from 'react-router-dom';
import { StationSideBar } from './StationSideBar/StationSideBar.component';
import { Station } from './StationContent/Station.component';
import { AddNewDeviceModal } from '../Modals/AddNewDeviceModal.component';
import { NocItemContext } from '../../../context/noc-item-context';
import { StationContext } from '../../../context/station-context';
import { findStation } from '../../../services/StationService';
import { UseNocItemContext } from '../../../pages/Dashboard/StationScreen';
import { LoadingModal } from '../Modals/LoadingModal.component';
import { useNotificationApi } from '../../UI/NotificationProvider';
import { Spin } from 'antd';

const paramsObj = {
    page : 0,
    limit: 10,
    filter: '',
    username: '',
}

export const RefreshCustomerContext = createContext(undefined);

export const CustomerViewLayout = ({...props}) => {

    const { pendingState, setPendingState, pendingChangesModal, setPendingChangesModal } = props;

    const notificationApi = useNotificationApi();
    const location = useLocation();
    const { currentNocItem } = location.state;
    const { Places } = UseNocItemContext();
    
    const [nocItem, dispatchNocItem] = useContext(NocItemContext);
    const [stationState, stationDispatch] = useContext(StationContext);
    const [stationListParams, setStationListParams] = useState({...paramsObj, username: currentNocItem.username});
    const [updateAllPendingChanges, setUpdateAllPendingChanges] = useState(false);
    const [addNewDeviceModal, setAddNewDeviceModal] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [refresh, setRefresh] = useState(false)
    const [refreshMessage, setRefreshMessage] = useState('');
    const [displaySpinner, setDisplaySpinner] = useState(false);

    useEffect(() => {
        setStationListParams({...paramsObj, username: currentNocItem.username})
    }, [currentNocItem.username])

    useEffect(() => {

        const dispatchHandler = (response) => {

            if(!stationListParams.filter){
                dispatchNocItem({
                    type: 'SET_TOTAL_STATIONS_COUNT', 
                    payload: response.entries?.length,
                });
            }

            dispatchNocItem({
                type: 'SET_STATION_LIST',
                payload: response.entries
            })
            dispatchNocItem({
                type: 'SET_ANTHEM_PROFILES',
                payload: response.anthemProfiles
            }); 
            dispatchNocItem({
                type: 'SET_RESPONSE_COUNTER',
                payload: response.counter
            });
            dispatchNocItem({
                type: 'SET_PROFILES',
                payload: response.profiles, 
            })
            
            setIsLoaded(true);
        }

        if (!pendingState){
            findStation(stationListParams).then( (response) => {
                if(refresh){
                    if(response){
                        if(refreshMessage){
                            setDisplaySpinner(true);
                            setTimeout(() => {
                                dispatchHandler(response);
                                setRefresh(false);
                                setDisplaySpinner(false);
                                notificationApi['success']({
                                    // message: 'Success!',
                                    description: refreshMessage,
                                });
                            }, 600);
                        } else {
                            dispatchHandler(response);
                            setRefresh(false);
                        }
                        
                        setRefreshMessage();
                    }
                } else {
                    dispatchHandler(response);
                }
            })
        }

    }, [dispatchNocItem, pendingState, stationListParams, stationDispatch, refresh, location.state]);

    useEffect(() => {
        if(nocItem.loading){
            setStationListParams({...stationListParams, page: 0});
            dispatchNocItem({
                type: 'LOADED'
            })
        }
    }, [nocItem.loading])

    useEffect(() => {
        if(!pendingState){
            setUpdateAllPendingChanges(false);
        }
    }, [pendingState, updateAllPendingChanges])
    
    return (
        <>
            { isLoaded && <> 
                <RefreshCustomerContext.Provider value={{ refresh, setRefresh, setRefreshMessage }}>
                    <StationSideBar 
                        pendingState={pendingState} 
                        setPendingChangesModal={setPendingChangesModal}
                        stationListParams={stationListParams}
                        setStationListParams={setStationListParams}
                    />
                    <Station 
                        pendingState={pendingState}
                        setPendingState={setPendingState}
                        pendingChangesModal={pendingChangesModal}
                        setPendingChangesModal={setPendingChangesModal}
                        updateAllPendingChanges={updateAllPendingChanges}
                        setUpdateAllPendingChanges={setUpdateAllPendingChanges}
                        refresh={refresh}
                    />

                    <AddNewDeviceModal addNewDeviceModal={addNewDeviceModal} setAddNewDeviceModal={setAddNewDeviceModal} />

                    <Spin spinning={displaySpinner} fullscreen/>
                </RefreshCustomerContext.Provider>
            </> }
        </>
    )
}